import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const LoginContainerWrapper = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const HeaderContainer = styled.div`
  margin-top: 40px;
`;

export const LogoWrapper = styled.div``;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const StyledHeader = styled.h1`
  margin: 60px 0px;
  color: ${(props) => props.theme.atlas.semantic.color.type.inverse};
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH2)}
`;

export const LoginContainerBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: center;
  margin-bottom: 40px;
`;

export const InputContainer = styled.div`
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 280px;

  & .formContainer {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
`;

export const HeaderMid = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
  font-weight: 600;
  display: flex;
  flex: 4;
  justify-content: center;
`;
export const HeaderRight = styled.div`
  display: flex;
  flex: 1;
`;
export const HeaderLeft = styled.div`
  display: flex;
  flex: 1;
`;

export const BackButton = styled.div`
  cursor: pointer;
`;

export const Description = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
`;

export const ButtonWrapper = styled.div`
  margin-top: 10px;
  width: 100%;
`;
